import NoInlineResultSearcher from "./NoInlineResultSearchers"

class GSSSearcher extends NoInlineResultSearcher {
    key = 'GSS';
    searcherName = 'NORC General Society Survey';
    infoText = 'NORC General Society Survey';
    typeFilter2urlSection = {"All types": null}
    multiTypeFilterSupported = false;
    dateFilterSupported = false;

    fillTargetWebsiteUrl(value, store) { 
        this.targetWebsiteUrl = "https://gss.norc.org/search?u=https%3A%2F%2Fgss%2Enorc%2Eorg%2Fgetthedata&k=" +
        encodeURIComponent(value);

    }
};

class USCensusSearcher extends NoInlineResultSearcher {
    key = 'USCensus';
    searcherName = 'US Census';
    infoText = 'US Census';
    typeFilter2urlSection = {"All types":  {suffix: ""},
                             "Images" : {suffix : "&searchtype=image",
                            "Video" : {suffix : "&searchtype=video"}}}
    multiTypeFilterSupported = false;
    dateFilterSupported = false;
    
    fillTargetWebsiteUrl(value, store) { 
        this.targetWebsiteUrl = "https://www.census.gov/search-results.html?q=" + 
        encodeURIComponent(value) 

    }
}; 

class PewSearcher extends NoInlineResultSearcher {
    key = 'Pew';
    searcherName = 'Pew Reaserch Center';
    infoText = 'Pew Reaserch Center';
    typeFilter2urlSection = {"All types": null}
    multiTypeFilterSupported = false;
    dateFilterSupported = true;

    fillTargetWebsiteUrl(value, store) { 
        this.targetWebsiteUrl = "https://www.pewresearch.org/search/" + 
        encodeURIComponent(value) +
        (store.searchInput.dates === null ? "" : "?yr_min=" + store.searchInput.dates[0] + "&yr_max=" + store.searchInput.dates[1]);

    }
}
export {GSSSearcher, USCensusSearcher, PewSearcher}